import React from 'react'
import useDimensions from '../../../hooks/use-dimensions'
import CheckedMultiSelector from '../../common/checked-multi-selector'
import useLearningResourcesFilters from '../../../hooks/use-learning-resources-filters'

const DimensionsFilter = ({
    disabled
}) => {
    const { dimensions: values, updateFilters } = useLearningResourcesFilters()
    const [ dimensions ] = useDimensions()
    return (
        <React.Fragment>
            <CheckedMultiSelector
                items={dimensions}
                title={values.length ? 'Dimensions' : 'All Dimensions'}
                onChange={l => updateFilters({ dimensions: l})}
                values={values || []}
                disabled={disabled}
                keyProp='id'
                valueProp='name'
            />
        </React.Fragment>
    )
}

export default DimensionsFilter